import { CnAgreement as UiCnAgreement } from "../../components/cn-agreement";
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnAgreement = connect(UiCnAgreement, mapProps({
    value: 'checked',
}, mapSize, mapStatus));
